// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-redundant-type-constituents */

export interface AlertData {
  id: string;
  category: number;
  symbol: string; // symbol
  alert_time: string; // ISO DateTime string
  payload: any | null;
  is_seen: boolean;
  is_visited: boolean;
}

// this must match what is in the middle layer in helpers/alerts
// prettier-ignore
export enum AlertCategory {
  HIRO_TOP_SIGNAL      = 1,      // "sell" signal
  HIRO_BOTTOM_SIGNAL   = 1 << 1, // "buy" signal
  HIRO_NEG_FLOW       = 1 << 2,
  HIRO_POS_FLOW        = 1 << 3,
  HIRO_FLOW_CLOSE_SELL = 1 << 4,
  HIRO_FLOW_CLOSE_BUY  = 1 << 5,
  CALL_WALL            = 1 << 16,
  PUT_WALL             = 1 << 17,
  ONE_PERCENT_CALL_WALL = 1 << 18,
  ONE_PERCENT_PUT_WALL = 1 << 19
}

export const HIRO_ALERTS = new Set([
  AlertCategory.HIRO_TOP_SIGNAL,
  AlertCategory.HIRO_BOTTOM_SIGNAL,
  AlertCategory.HIRO_NEG_FLOW,
  AlertCategory.HIRO_POS_FLOW,
  AlertCategory.HIRO_FLOW_CLOSE_SELL,
  AlertCategory.HIRO_FLOW_CLOSE_BUY,
]);

// this must match what is in the middle layer in helpers/alerts
const DisabledAlertCategories = new Set([
  AlertCategory.HIRO_FLOW_CLOSE_BUY,
  AlertCategory.HIRO_FLOW_CLOSE_SELL,
  AlertCategory.HIRO_TOP_SIGNAL,
  AlertCategory.HIRO_BOTTOM_SIGNAL,
]);

export const AllExposedAlertCategories = Object.keys(AlertCategory)
  .filter((key) => Number.isNaN(Number(key)))
  .map((c: any) => AlertCategory[c] as any)
  .filter((c) => !DisabledAlertCategories.has(c)) as AlertCategory[];

export function getDesc(alertCategory: AlertCategory) {
  switch (alertCategory) {
    case AlertCategory.HIRO_TOP_SIGNAL:
    case AlertCategory.HIRO_BOTTOM_SIGNAL:
      return 'HIRO Volatility';
    case AlertCategory.HIRO_NEG_FLOW:
    case AlertCategory.HIRO_POS_FLOW:
      return 'HIRO Flow';
    case AlertCategory.HIRO_FLOW_CLOSE_BUY:
    case AlertCategory.HIRO_FLOW_CLOSE_SELL:
      return 'Close H-Flow';
    case AlertCategory.CALL_WALL:
      return 'Call Wall Breached';
    case AlertCategory.PUT_WALL:
      return 'Put Wall Breached';
    case AlertCategory.ONE_PERCENT_CALL_WALL:
      return 'Within 1% of Call Wall';
    case AlertCategory.ONE_PERCENT_PUT_WALL:
      return 'Within 1% of Put Wall';
  }
}

export const alertCategoryDescriptions: any = {};
for (const category of AllExposedAlertCategories) {
  const desc = getDesc(category as AlertCategory);
  if (desc == null) {
    continue;
  }
  alertCategoryDescriptions[desc] = alertCategoryDescriptions[desc] ?? [];
  alertCategoryDescriptions[desc].push(category);
}

export enum ShowingAlertType {
  All,
  Watchlists,
}

export const HiroAlertCategoryMap: Record<string, AlertCategory> = {
  'HIRO Volatility Top': AlertCategory.HIRO_TOP_SIGNAL,
  'HIRO Volatility Bottom': AlertCategory.HIRO_BOTTOM_SIGNAL,
  'HIRO Flow Negative': AlertCategory.HIRO_NEG_FLOW,
  'HIRO Flow Positive': AlertCategory.HIRO_POS_FLOW,
  'Close H-Flow Sell': AlertCategory.HIRO_FLOW_CLOSE_SELL,
  'Close H-Flow Buy': AlertCategory.HIRO_FLOW_CLOSE_BUY,
};
export type HiroAlertCategory = keyof typeof HiroAlertCategoryMap;
export const HiroAlertCategories: HiroAlertCategory[] =
  Object.keys(HiroAlertCategoryMap);

export const HiroAlertCategoryFromAlertCategory: Record<
  AlertCategory,
  HiroAlertCategory
> = Object.fromEntries(
  Object.entries(HiroAlertCategoryMap).map(([a, b]) => [b, a]),
);
